import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import { Text } from 'modules/common';

import * as c from './constants';

function NavListItem({ label, isActive, onClick }) {
  const $type = isActive ? c.dispatchType?.active : c.dispatchType?.default;

  const style = {
    text: $type?.text,
    background: $type?.background,
  };

  return (
    <button
      type="button"
      className={cn(
        'text-left w-full py-ds-16 px-ds-24 relative',
        style.background
      )}
      onClick={onClick}
    >
      {isActive && (
        <div className="absolute top-0 left-0 h-full w-[5px] bg-brand-primary-base rounded-r" />
      )}

      <Text className={cn(style.text)} weight="semibold">
        {label}
      </Text>
    </button>
  );
}

NavListItem.defaultProps = {
  label: '',
  isActive: false,
  onClick: () => {},
};

NavListItem.propTypes = {
  label: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.instanceOf(Function),
};

export default NavListItem;
